import BATCH from "../backend/preCompiles/BATCH.json";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

//initializes and return batch contract properties
const batchInit = (web3) => {
  const networkKey = Object.keys(BATCH.networks)[0];
  return new web3.eth.Contract(BATCH.abi, BATCH.networks[networkKey].address);
};

//excutes contracts functions in batch
const batchFunction = async (
  batch,
  addresses,
  values,
  callData,
  gasLimits,
  userAccount
) => {
  const res = await batch.methods
    .batchAll(addresses, values, callData, gasLimits)
    .send({ from: userAccount })
    .then(() => {
      return true;
    })
    .catch((err) => {
      if (err.message.includes("Response has no error or result for request")) {
        toast.error(
          "You are offline due to internet connection. check your connection and try again"
        );
      } else {
        console.log("Unexpected error while creating profile :", err);
        toast.error("Unexpected error while creating profile. Try again later");
      }
      return false;
    });
  return res;
};

export { batchInit, batchFunction };
